import { TableDataItem } from '~/components/ui/tables/Table';
import { getFarmResidentialBuildingFieldConfigs } from './shared-building-fields';
import { filterProviderData } from './utils';
import { NestedHome } from '@habity/types';
import { FarmInfoEstateOtherResidentialBuilding } from '@habity/types/vitec/common/farmInfoEstateOtherResidentialBuilding';
import { CommonEstateRoom } from '@habity/types/vitec/common/commonEstateRoom';

export const getBuildingDataForFarm = (
  building: FarmInfoEstateOtherResidentialBuilding
): TableDataItem[] => {
  const data: TableDataItem[] = [];
  const fieldConfigs = getFarmResidentialBuildingFieldConfigs();

  // Filter the entire building data upfront to handle "None", empty values, etc.
  const filteredBuilding = filterProviderData(building);

  for (const config of fieldConfigs) {
    // FIXME: This is only here for now because I'm getting some undefined configs for farms
    if (!config || !config.key) continue;

    const value = getValue(config.key, filteredBuilding);

    if (shouldIncludeField(value)) {
      const formattedValue = config.formatter
        ? config.formatter(value, { filteredProviderData: filteredBuilding })
        : String(value);

      const label =
        typeof config.label === 'function'
          ? config.label({
            filteredProviderData: filteredBuilding,
            home: {} as NestedHome,
            provider_data: building,
            provider_type: null,
            address: {},
            isApartment: false,
          })
          : config.label;

      data.push({
        ...(config.icon && { icon: config.icon }),
        label,
        value: formattedValue,
      });
    }
  }

  return data;
};

/**
 * Helper function to get nested property values
 */
function getValue(key: string, building: unknown): unknown {
  const keys = key.split('.');
  return keys.reduce((obj: unknown, k: string) => {
    if (obj && typeof obj === 'object' && k in obj) {
      return (obj as Record<string, unknown>)[k];
    }
    return undefined;
  }, building);
}

/**
 * Helper function to check if field should be included
 */
function shouldIncludeField(value: unknown): boolean {
  return (
    value !== null &&
    value !== undefined &&
    value !== '' &&
    !(typeof value === 'string' && value.trim() === '') &&
    !(typeof value === 'string' && value.trim().toLowerCase() === 'none')
  );
}

export const getRoomsDataForFarmResidentialBuilding = (
  building: FarmInfoEstateOtherResidentialBuilding
): TableDataItem[] => {
  if (!building.rooms || building.rooms.length === 0) {
    return [];
  }

  return building.rooms
    .filter((room): room is CommonEstateRoom => Boolean(room))
    .map((room) => ({
      label: room.heading || 'Rum',
      value: room.text || '',
    }));
};
